import { render, staticRenderFns } from "./ServerBank.vue?vue&type=template&id=52f77e56&scoped=true"
import script from "./ServerBank.vue?vue&type=script&lang=js"
export * from "./ServerBank.vue?vue&type=script&lang=js"
import style0 from "./ServerBank.vue?vue&type=style&index=0&id=52f77e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f77e56",
  null
  
)

export default component.exports